module.exports = __webpack_public_path__ + "static/media/foodbank.113ad703.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/foodbank.png
// module id = 174
// module chunks = 0